var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfqBox3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 33.5L12 53L54.5 55L67.5 39L76.5 55H120L109 33.5H24.5Z",
    fill: "#8F9DB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 111H27L25 55.5H56L66.5 39L76 55.5H105V111Z",
    fill: "#DBE3EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0281 104.037H91.1824V109.091H75.6364L90.5166 77.0909H98.1213L103.329 87.6306V109.091H97.4139V104.037H101.568L94.2981 87.2205L87.0281 104.037Z",
    fill: "#06CEA8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2843 98.5476C54.2843 99.4758 53.9148 99.8822 53.2591 100.538C52.6034 101.198 51.7121 101.078 50.7839 101.078H36.5661C34.6359 101.078 33.0659 100.483 33.0659 98.5477C33.0659 96.6175 34.6359 96.0172 36.5661 96.0172H50.7839C51.7121 96.0172 52.6034 95.9018 53.2591 96.5575C53.9148 97.2132 54.2843 97.6194 54.2843 98.5476ZM25.2705 35.6028H63.6069L53.6464 52.1573H15.31L25.2705 35.6028ZM106.627 35.6028L117.072 53.127H78.2509L68.7707 35.6028H106.627ZM103.117 108.629L103.113 57.2183H76.1955C74.9303 57.2183 73.7619 56.5302 73.1432 55.422L68.2253 45.009L68.2299 108.632L103.117 108.629ZM28.2855 57.2183V108.632H63.658L63.6626 45.009L58.2599 55.422C57.6411 56.5303 56.4774 57.2183 55.2075 57.2183H28.2855ZM20.6522 33.3115L10.1513 52.0002C9.53715 53.0808 9.54638 54.4108 10.1744 55.4867C10.8024 56.5626 11.9569 57.223 13.1991 57.223H23.2243L23.229 106.426C23.2336 110.166 26.2628 113.2 30.0079 113.204H101.39C105.135 113.2 108.164 110.166 108.174 106.426V57.2183H118.199C119.446 57.2183 120.591 56.5579 121.219 55.4819C121.847 54.4106 121.856 53.0807 121.247 52.0001L110.746 33.3114C110.127 32.2032 108.959 31.5151 107.693 31.5151H23.6954C22.4301 31.5151 21.2663 32.2033 20.6522 33.3115Z",
    fill: "#3B4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqBox3);
export default __webpack_public_path__ + "static/media/rfq-box3.5db8cab2fe0cc7e45f45b8a297827711.svg";
export { ForwardRef as ReactComponent };